import React from 'react'

import { isAxiosError } from 'axios'
import { useForm } from 'react-hook-form'
import {
  Button,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
} from '@chakra-ui/react'

import api from '@/api'
import { useUser } from '@/react-query/user'

interface EmailForm {
  email: string
}

interface EmailInputProps {
  setIsMessageShown: React.Dispatch<React.SetStateAction<boolean>>
}

export const EmailInput: React.FC<EmailInputProps> = ({
  setIsMessageShown,
}) => {
  const { data: user } = useUser()

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    register,
  } = useForm<EmailForm>({
    defaultValues: {
      email: '',
    },
  })

  const onEmailSent = async ({ email }: EmailForm) => {
    try {
      await api.sendReferralInvitation({
        email,
        dataVariables: {
          referralCode: user?.referralCode || '',
          name: user?.displayName || 'Your friend',
        },
      })
      setIsMessageShown(true)
    } catch (error) {
      setIsMessageShown(false)
      if (isAxiosError(error) && error.response?.status === 429) {
        setError('email', {
          message:
            'You have already sent an invitation to this email. Please try again later',
        })
        return
      }

      setError('email', { message: 'Something went wrong' })
    }
  }

  return (
    <form onSubmit={handleSubmit(onEmailSent)}>
      <FormControl isInvalid={Boolean(errors.email?.message)}>
        <InputGroup
          display={'flex'}
          flexDirection={'row'}
          background={'white'}
          rounded={'full'}
        >
          <Input
            placeholder="Work email"
            type={'email'}
            variant={'brand-solid-white'}
            rounded={'full'}
            id={'email'}
            {...register('email', {
              required: true,
            })}
          />
          <Button
            rounded={'1.25rem'}
            isLoading={isSubmitting}
            type="submit"
            display="flex"
            fontWeight={'bold'}
            variant={'brand-solid-white'}
            px={5}
            flexShrink={0}
          >
            Invite
          </Button>
        </InputGroup>
        <FormErrorMessage>
          {errors.email && errors.email.message}
        </FormErrorMessage>
      </FormControl>
    </form>
  )
}
